import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import AppGallery from './components/AppGallery';
import Home from './pages/Home';
import About from './pages/About';
import VisionMission from './pages/VisionMission';
import Services from './pages/Services';
import Applications from './pages/Applications';
import Contact from './pages/Contact';
import './App.css';
import './styles/classic-theme.css'; // 2010'lar Web Klasiği Stilleri

function App() {
  // Sadece F5 / Sayfa Yenileme (Reload) durumunda son sayfayı hatırla.
  // Sekme kapatılıp sıfırdan girilirse daima 'home' açılır.
  const [currentPage, setCurrentPage] = useState(() => {
    try {
      const navEntries = window.performance && window.performance.getEntriesByType('navigation');
      const isReload = navEntries && navEntries.length > 0
        ? navEntries[0].type === 'reload'
        : (window.performance && window.performance.navigation && window.performance.navigation.type === 1);

      if (isReload) {
        const savedPage = sessionStorage.getItem('akinevo_active_page');
        if (savedPage) return savedPage;
      } else {
        // Yeni bir giriş ise önceki oturum kalıntısını temizle
        sessionStorage.removeItem('akinevo_active_page');
      }

      // Varsa eski hash desteği (isteğe bağlı geriye dönük uyumluluk)
      if (window.location.hash === '#ekranlar') return 'gallery';
      if (window.location.hash === '#yorumlar') return 'testimonials';
    } catch (e) {
      // Hata durumunda varsayılan
    }
    return 'home';
  });

  // localStorage'dan tema tercihini al (varsayılan: 'modern')
  const [themeMode, setThemeMode] = useState(() => {
    return localStorage.getItem('akinevo_theme_mode') || 'modern';
  });

  useEffect(() => {
    // Adres çubuğunda # kaldıysa temizle (her zaman akinevo.com kalsın)
    if (window.location.hash) {
      window.history.replaceState('', document.title, window.location.pathname);
    }
  }, []);

  useEffect(() => {
    // Aktif sayfayı sessionStorage'a yaz (F5 yapılırsa hatırlaması için)
    try {
      if (currentPage === 'home') {
        sessionStorage.removeItem('akinevo_active_page');
      } else {
        sessionStorage.setItem('akinevo_active_page', currentPage);
      }
    } catch (e) {}
  }, [currentPage]);

  useEffect(() => {
    // Body sınıfını tema ile senkronize et
    document.body.classList.remove('mode-modern', 'mode-classic');
    document.body.classList.add(`mode-${themeMode}`);
  }, [themeMode]);

  // Tema değiştirme ve localStorage'a kaydetme fonksiyonu
  const handleToggleTheme = (mode) => {
    setThemeMode(mode);
    localStorage.setItem('akinevo_theme_mode', mode);
  };

  const navigateTo = (page, anchor = '') => {
    setCurrentPage(page);

    // Adres çubuğu daima tertemiz kalsın (# veya ek uzantı olmadan)
    if (window.location.hash) {
      window.history.replaceState('', document.title, window.location.pathname);
    }

    if (anchor) {
      setTimeout(() => {
        const el = document.getElementById(anchor);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={`app-container mode-${themeMode}`}>
      {currentPage !== 'gallery' && (
        <Navbar
          currentPage={currentPage}
          onNavigate={navigateTo}
          themeMode={themeMode}
          onToggleTheme={handleToggleTheme}
        />
      )}
      <main className="main-content">
        {currentPage === 'home' && (
          <>
            <Home themeMode={themeMode} />
            <About />
            <VisionMission />
            <Services />
            <Applications onNavigate={navigateTo} />
            <Process />
            <Contact />
          </>
        )}
        {currentPage === 'testimonials' && (
          <Testimonials />
        )}
        {currentPage === 'gallery' && (
          <AppGallery onBackToHome={() => navigateTo('home', 'uygulamalar')} />
        )}
      </main>
      <Footer onNavigate={navigateTo} />
    </div>
  );
}

export default App;
